export enum EventType {
    'REFRESH.MENU.USER_DATA' = 'REFRESH.MENU.USER_DATA',
    'REFRESH.PERSONAL_DATA_PANE.PROFILE_DATA' = 'REFRESH.PERSONAL_DATA_PANE.PROFILE_DATA',
}